(function(jQuery)
{
	jQuery.framework = jQuery.framework || {};
	
	jQuery.framework.equalheight = function()
	{
		jQuery(".equalheight").css("height", "");
		jQuery(".equalheight").children().css("height", "");
		
		jQuery(".equalheight").each(function()
		{
			heights = new Array();
				
			jQuery(this).children("div, nav").each(function()
			{	
				height = jQuery(this).outerHeight();
				
				//strip "px" - http://stackoverflow.com/questions/1100503/how-to-get-just-numeric-part-of-css-property-with-jquery
				heights.push(height);
			});
			
			maxHeight = Math.max.apply(Math, heights);
			
			jQuery(this).children("div, nav").css("height", "");
			jQuery(this).children("div, nav").each(function()
			{
				jQuery(this).css("height", maxHeight + "px");
			});
		});
	}
})(jQuery);

jQuery.framework.equalheight();
jQuery(window).load(function()
{
	jQuery.framework.equalheight();
	
	jQuery(window).resize(jQuery.framework.equalheight);
});
